<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <!-- Dialog error autorizacao -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="autorizacaoDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">Mensagem do Sistema</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemAutorizacaoDialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="logout">Logout</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="dialogRelatorio" fullscreen max-width="100%" style="z-index: 8000">
      <DetalhesViagem ref="detalheViagem" :linhas="linhas" :viagem="editedItem" :user="user" :token="token"
        :key="relatorioKey" @close="closeRelatorio"></DetalhesViagem>
    </v-dialog>

    <v-alert :type="tipoAlerta" timeout="5000" dismissible v-model="showAlert"
      style="margin-bottom: 35px; border-radius: 10px">
      {{ this.mensagemAlerta }}
    </v-alert>

    <v-dialog v-model="dialogObservacoesAuditoria" max-width="80%">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialogObservacoesAuditoria">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t('relPredictedRealized.auditObservations') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="podeVerTrilhaAuditoria && viagemObservacoesAuditoria" text dark
            :to="{ path: '/audit/auditoriaviagens', query: { id_viagem_grid: viagemObservacoesAuditoria } }">
            <v-icon left>mdi-timeline-text-outline</v-icon>
            {{ $t('relPredictedRealized.auditTrail') }}
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <merus-data-table :headers="headersObservacoesAuditoria" :items="observacoesAuditoria"
            :loading="loadingObservacoesAuditoria" :default-multi-sort="defaultMultiSortObservacoesAuditoria"
            cod-tabela="RELPREVREAL__OBSERVACOES_AUDITORIA"
            @update:headers="headersObservacoesAuditoria = $event">
            <template v-slot:toolbar>
              <CadastroToolbar :title="$t('relPredictedRealized.auditObservations')" :token="token"
                :items="observacoesAuditoria" csv-title="observacoesauditoria"
                :csv-headers="headersObservacoesAuditoria" :pdf-title="$t('relPredictedRealized.auditObservations')"
                :pdf-headers="headersObservacoesAuditoria" pdf-filename="observacoesauditoria" hide-search>
              </CadastroToolbar>
            </template>
          </merus-data-table>

          <v-textarea v-model="listaObservacoesAuditoria" :label="$tc('system.labels.observation', 2)"
            readonly></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="80%">
      <v-card>
        <v-card-title>
          <span class="headline" style="color: #4a4a4a">Detalhes da Viagem</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="editForm" v-model="formValidado">
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="editedItem.cod_linha" readonly :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="editedItem.descricao_sentido" readonly :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="editedItem.escalonamento_viagem" label="Escalonamento" readonly
                    :disabled="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="editedItem.numero_guia_realizada" readonly label="Guia"
                    :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="editedItem.numero_ordem_veiculo_realizado" label="Veículo" readonly
                    :disabled="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.saida_prevista_extenso" label="Horário de Saída Previsto"
                    prepend-icon="mdi-clock" readonly :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.saida_realizada_extenso" label="Horário de Saída Realizado"
                    prepend-icon="mdi-clock" readonly :disabled="editedItem.sem_inicio != 1"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.chegada_prevista_extenso" label="Horário de Chegada Previsto"
                    prepend-icon="mdi-clock" readonly :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field v-model="editedItem.chegada_realizada_extenso" label="Horário de Chegada Realizado"
                    prepend-icon="mdi-clock" readonly :disabled="editedItem.sem_final != 1"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-divider></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="4">
                  <v-select v-model="preferenciaGuiaValidador.flag" :items="prefSelect" label="Origem Funcionário"
                    item-text="descricao" item-value="flag" @change="alterarPreferenciaGuiaValidador(editedItem)"
                    :disabled="false"></v-select>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="preferenciaGuiaValidador.descricao_motorista" label="Motorista" readonly
                    :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                  <v-text-field v-model="preferenciaGuiaValidador.descricao_cobrador" label="Cobrador" readonly
                    :disabled="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="editedItem.dt_alteracao_pref_guia_validador_extenso"
                    label="Última alteração em" readonly :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="editedItem.nome_usuario_alteracao_pref_guia_validador" label="Por" readonly
                    :disabled="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-divider></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="editedItem.nome_cerca_inicio" label="Cerca de Início" readonly
                    :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-text-field v-model="editedItem.nome_cerca_fim" label="Cerca de Chegada" readonly
                    :disabled="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field :value="editedItem.tipo_abertura" label="Abertura" readonly
                    :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field :value="editedItem.dt_abertura_manual_extenso" label="Aberto em" readonly
                    :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field :value="editedItem.nome_usuario_abertura_manual" label="Usuário" readonly
                    :disabled="true"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field :value="editedItem.tipo_fechamento" label="Fechamento" readonly
                    :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field :value="editedItem.dt_fechamento_manual_extenso" label="Fechado em" readonly
                    :disabled="true"></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <v-text-field :value="editedItem.nome_usuario_fechamento_manual" label="Usuário" readonly
                    :disabled="true"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <v-card>
              <v-card-title>
                <span class="headline" style="color: #4a4a4a">
                  Diário de Bordo
                </span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="diarioForm" v-model="diarioFormValidado">
                    <v-row>
                      <v-col cols="12" sm="12" md="4">
                        <v-autocomplete v-model="itemDiario.id_tipo_entrada_diario" :items="tiposEntradaDiario"
                          item-text="descricao_tipo_entrada" item-value="id_tipo_entrada_diario" clearable label="Tipo"
                          :disabled="tipoEntradaDisabled" :rules="[(v) => !!v || 'Tipo é obrigatório']">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-autocomplete v-model="itemDiario.id_motivo" :items="motivos" item-text="descricao_motivo"
                          item-value="id_motivo" clearable label="Motivo"
                          :rules="[(v) => !!v || 'Motivo é obrigatório']">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <v-datetime-picker label="Data Entrada" v-model="dtEntradaDiario"
                          :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                          date-format="dd/MM/yyyy" clear-text="Fechar"
                          :rules="[(v) => !!v || 'Data é obrigatória']">
                          <template slot="dateIcon">
                            <v-icon>mdi-calendar</v-icon>
                          </template>
                          <template slot="timeIcon">
                            <v-icon>mdi-clock</v-icon>
                          </template>
                        </v-datetime-picker>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="10" md="10">
                        <v-textarea v-model="itemDiario.observacoes" label="Observações" auto-grow clearable counter
                          rows="1" :rules="[(v) => (v === null || v.length <= 1000) || 'Máximo de 1000 caracteres']">
                        </v-textarea>
                      </v-col>
                      <v-col cols="12" sm="2" md="2">
                        <v-btn color="primary" dark small class="mb-2" fab @click="saveEntrada">
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-row>
                    <v-container>
                      <v-data-table :headers="headersDiario" :items="entradasDiario" sort-by="dt_entrada" dense
                        class="elevation-7" locale="pt" :loading="loadingDiario" show-expand :single-expand="true"
                        item-key="id_entrada_diario" loading-text="Carregando..." style="border-radius: 10px">
                        <template v-slot:expanded-item="{ headers, item }">
                          <td :colspan="headers.length" style="margin: 0;padding: 5px;">
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th>Registrado Por</th>
                                    <th>Registrado Em</th>
                                    <th>Editado Por</th>
                                    <th>Editado Em</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{{ item.usuario_inclusao }}</td>
                                    <td>{{ item.dt_inclusao }}</td>
                                    <td>{{ item.usuario_edicao }}</td>
                                    <td>{{ item.dt_edicao }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </td>
                        </template>
                      </v-data-table>
                    </v-container>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" class="white--text" @click="close">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <LazySelect
              ref="empresaSelect"
              get-url="getEmpresaslazy"
              :extra-items="empresas"
              text="razao_social"
              value="id_empresa"
              :label="$tc('company.self', 1)"
              @input="onEmpresaInput"
            />
          </v-col>
          <!-- adicionar unidade -->
          <v-col cols="12" sm="6" md="4">
            <MultiplaEscolha
              ref="unidadesSelect"
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <!-- termina unidade -->
          <v-col cols="12" sm="6" md="4">
            <MultiplaEscolha
              ref="linhasSelect"
              lazy
              get-url="getLinhaslazy"
              :request-data="lazySelectRequestData"
              v-bind:selected-items.sync="idLinhaSelected"
              text="nome_linha"
              value="id_linha"
              :label="$tc('line.self', 1)"
              :max-items="2"
              :disabled="isLinhaSelectDisabled"
            />
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="2" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaRelatorio">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-expansion-panels style="margin-bottom: 10px; border-radius: 10px; margin-top: 10px;">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3 style="color: #4a4a4a">{{ $t('relPredictedRealized.aggregates') }}</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-tabs v-model="tab" @change="buildHeader">
            <v-tab>{{ $tc('vehicle.self', 2) }}</v-tab>
            <v-tab>{{ $tc('guide.self', 2) }}</v-tab>
            <v-tab>{{ $tc('line.self', 2) }}</v-tab>
          </v-tabs>

          <v-data-table :headers="headersAgregado" :items="agregado" :sort-by="sortByAgregado" dense class="elevation-7"
            locale="pt" :loading="loadingAgregado" :loading-text="$t('system.messages.loading')"
            :search="searchAgregado" style="border-radius: 10px; margin-bottom: 10px;">
            <template v-slot:top>
              <v-toolbar flat color="white" style="border-radius: 10px;">
                <v-spacer></v-spacer>
                <v-text-field v-model="searchAgregado" append-icon="mdi-magnify" :label="$t('relVehicleKm.filter')"
                  single-line hide-details></v-text-field>
                <v-spacer></v-spacer>

                <v-switch v-model="porDia" :label="$t('routeCompliance.perDay')" color="primary"
                  @change="togglePorDia"></v-switch>

                <v-spacer></v-spacer>
                <vue-json-to-csv :json-data="agregado" :csv-title="'previstorealizadoagregado'" separator=";">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                        <v-icon>mdi-export-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('system.labels.exportToCsv') }}</span>
                  </v-tooltip>
                </vue-json-to-csv>

                <ExportTablePdf :title="$t('relPredictedRealized.title')" :content="agregado" :headers="headersAgregado"
                  filename="relprevistorealizadoagregado"></ExportTablePdf>
              </v-toolbar>
            </template>

            <template v-slot:item.p_previstas="{ item }">
                  <PercentItem :value="item.p_previstas"></PercentItem>
                </template>

                <template v-slot:item.p_realizadas="{ item }">
                  <PercentItem :value="item.p_realizadas"></PercentItem>
                </template>

                <template v-slot:item.p_previstas_produtivas="{ item }">
                  <PercentItem :value="item.p_previstas_produtivas"></PercentItem>
                </template>

                <template v-slot:item.p_realizadas_produtivas="{ item }">
                  <PercentItem :value="item.p_realizadas_produtivas"></PercentItem>
                </template>

                <template v-slot:item.p_completas="{ item }">
                    <PercentItem :value="item.p_completas"></PercentItem>
                </template>

                <template v-slot:item.p_incompletas="{ item }">
                    <PercentItem :value="item.p_incompletas"></PercentItem>
                </template>

                <template v-slot:item.p_adiantadas="{ item }">
                    <PercentItem :value="item.p_adiantadas"></PercentItem>
                </template>

                <template v-slot:item.p_atrasadas="{ item }">
                    <PercentItem :value="item.p_atrasadas"></PercentItem>
                </template>

                <template v-slot:item.p_extras="{ item }">
                    <PercentItem :value="item.p_extras"></PercentItem>
                </template>

                <template v-slot:item.p_nao_realizadas="{ item }">
                    <PercentItem :value="item.p_nao_realizadas"></PercentItem>
                </template>

                <template v-slot:item.p_perdidas="{ item }">
                    <PercentItem :value="item.p_perdidas"></PercentItem>
                </template>

                <template v-slot:item.temp_media="{ item }">
                  {{ getWeatherTemp(item) }}
                </template>

          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Mês fechado: as viagens do período estão congeladas e a API recusa a alteração. -->
    <v-alert v-if="mesesFechadosConsultados.length" type="info" dense text icon="mdi-lock-outline"
      style="margin-bottom: 10px; border-radius: 10px">
      {{ $t('closingMonth.editBlockedBanner', { meses: mesesFechadosConsultados.join(', ') }) }}
    </v-alert>

    <merus-data-table
      :headers="headers"
      :items="viagens"
      :loading="loadingViagens"
      :loading-text="$t('system.messages.loading')"
      :default-multi-sort="defaultMultiSortViagens"
      item-key="id_viagem_grid"
      cod-tabela="RELPREVREAL"
      append-actions
      actions-i18n-key="relPredictedRealized.actions"
      @update:headers="headers = $event"
      @update:displayedItems="displayedItemsForExport = $event">
      <template v-slot:toolbar>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ $t('relPredictedRealized.title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <vue-json-to-csv :json-data="displayedItemsForExport || viagens" :csv-title="'relprevistorealizado'" separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>
          <ExportTablePdf :title="$t('relPredictedRealized.title')" :content="displayedItemsForExport || viagens"
            :headers="headers" filename="relprevistorealizado"></ExportTablePdf>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="orange" @click="abrirRelatorioViagem(item)"
          :disabled="!item.has_relatorio">mdi-clipboard-file</v-icon>
        <v-icon small class="mr-2" color="green" @click="editViagem(item)"
          :disabled="(!item.horario_saida_realizada && !item.horario_chegada_realizada) || viagemEmMesFechado(item, idEmpresaSelected)">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="red" @click="abrirObservacoesAuditoria(item)">mdi-alert-box-outline</v-icon>
      </template>

      <template v-slot:item.temp_media="{ item }">
        {{ getWeatherTemp(item) }}
      </template>

      <template v-slot:item.saida_realizada_extenso="props">
        <v-icon v-if="props.item.sem_inicio == 1" color="red">mdi-alert-circle-outline</v-icon>
        <v-edit-dialog :return-value.sync="props.item.saida_realizada_extenso" @save="saveHorarioEdit(props.item)"
          @close="closeHorarioEdit" v-if="props.item.sem_inicio == 1 && !viagemEmMesFechado(props.item, idEmpresaSelected)">
          {{ props.item.saida_realizada_extenso }}
          <template v-slot:input>
            <v-datetime-picker v-model="novoHorarioSaida" :label="$t('monitor.trip.departure')"
              :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')"></v-datetime-picker>
          </template>
        </v-edit-dialog>
        <span v-else>{{ props.item.saida_realizada_extenso }}</span>
      </template>

      <template v-slot:item.chegada_realizada_extenso="props">
        <v-icon v-if="props.item.sem_final == 1" color="red">mdi-alert-circle-outline</v-icon>
        <v-edit-dialog :return-value.sync="props.item.chegada_realizada_extenso" @save="saveHorarioEdit(props.item)"
          @close="closeHorarioEdit" v-if="props.item.sem_final == 1 && !viagemEmMesFechado(props.item, idEmpresaSelected)">
          {{ props.item.chegada_realizada_extenso }}
          <template v-slot:input>
            <v-datetime-picker v-model="novoHorarioChegada" :label="$t('monitor.trip.arrival')"
              :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')"></v-datetime-picker>
          </template>
        </v-edit-dialog>
        <span v-else>{{ props.item.chegada_realizada_extenso }}</span>
      </template>

      <template v-slot:item.km_total="{ item }">
        <div>{{ item.km_total?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.diesel_total="{ item }">
        <div>{{ item.diesel_total?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.diesel_km="{ item }">
        <div>{{ item.diesel_km?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.condicao_climatica="{ item }">
        <v-icon :color="getWeatherIconColor(item)">{{ getWeatherIcon(item) }}</v-icon>
      </template>
    </merus-data-table>

    <merus-data-table
      :headers="headersEmbarquesForaViagem"
      :items="embarquesForaViagemFiltrados"
      :loading="loadingEmbarquesForaViagem"
      :loading-text="$t('system.messages.loading')"
      :default-multi-sort="defaultMultiSortEmbarquesForaViagem"
      item-key="id_embarque"
      style="border-radius: 10px; margin-top: 20px;"
      cod-tabela="RELPREVREAL__EMBARQUES_FORA_VIAGEM"
      @update:displayedItems="displayedEmbarquesForaViagemForExport = $event"
      @update:headers="headersEmbarquesForaViagem = $event">
      <template v-slot:toolbar>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ $t('relPredictedRealized.embarquesForaViagemTitle') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <vue-json-to-csv
            :json-data="displayedEmbarquesForaViagemForExport || embarquesForaViagemFiltrados"
            :csv-title="'relprevistorealizadoembarquesforaviagem'"
            separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>
          <ExportTablePdf
            :title="$t('relPredictedRealized.embarquesForaViagemTitle')"
            :content="displayedEmbarquesForaViagemForExport || embarquesForaViagemFiltrados"
            :headers="headersEmbarquesForaViagem"
            filename="relprevistorealizadoembarquesforaviagem"></ExportTablePdf>
        </v-toolbar>
      </template>

      <template v-slot:item.autorizado_extenso="{ item }">
        <v-icon small class="mr-2" :color="item.autorizado == 1 ? 'green' : item.autorizado == 2 ? 'orange' : 'red'">mdi-circle</v-icon>
      </template>

      <template v-slot:item.sem_posicoes_janela="{ item }">
        <v-tooltip bottom v-if="Number(item.sem_posicoes_janela) === 1">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="orange darken-2" v-bind="attrs" v-on="on">mdi-alert</v-icon>
          </template>
          <span>{{ $t('relBoarding.noPositionsTooltip') }}</span>
        </v-tooltip>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import DetalhesViagem from "./DetalhesViagem.vue";
import DateUtils from "../utils/dateutils.js";
import PercentItem from "./PercentItem.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import EventBus from "@/utils/eventBus";
import VueJsonToCsv from 'vue-json-to-csv';
import ExportTablePdf from './ExportTablePdf.vue';
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import LazySelect from './Selects/LazySelect.vue';
import fechamentoMesMixin from '@/mixins/fechamentoMesMixin';
export default {
  mixins: [fechamentoMesMixin],
  components: {
    DetalhesViagem,
    PercentItem,
    VueJsonToCsv,
    ExportTablePdf,
    MerusDataTable,
    CadastroToolbar,
    MultiplaEscolha,
    LazySelect,
  },
  data: () => ({
    search: "",
    searchAgregado: "",
    user: null,
    token: null,
    tab: 0,
    showConfirmButton: true,
    formValidado: false,
    loadingViagens: false,
    loadingAgregadoLinhas: false,
    loadingAgregadoVeiculos: false,
    loadingAgregadoGuias: false,
    loadingUpdate: false,
    autorizacaoDialog: false,
    mensagemAutorizacaoDialog: "",
    tipoAlerta: "success",
    mensagemAlerta: "",
    showAlert: false,
    headers: [],
    headersDiario: [
      { text: "Id Entrada", value: "id_entrada_diario", align: " d-none"},
      { text: "Data", value: "dt_entrada" },
      { text: "Tipo", value: "descricao_tipo_entrada" },
      { text: "Motivo", value: "descricao_motivo" },
      { text: "Observações", value: "observacoes" },
    ],
    headersAgregado: null,
    timeProps: {
      useSeconds: true,
    },
    porDia: false,
    dti: null,
    dtf: null,
    idEmpresaSelected: null,
    idLinhaSelected: [],
    empresas: [],
    linhas: [],
    linhasSelect: [],
    unidadesSelecionadas: [],
    veiculos: [],
    veiculosSelect: [],
    posicoes: [],
    viagens: [],
    embarquesForaViagem: [],
    loadingEmbarquesForaViagem: false,
    displayedEmbarquesForaViagemForExport: null,
    headersEmbarquesForaViagem: [],
    viagensNaoAssociadas: [],
    idguias: [],
    agregado: [],
    agregadoVeiculos: [],
    agregadoGuias: [],
    agregadoLinhas: [],
    agregadoVeiculosPorDia: [],
    agregadoGuiasPorDia: [],
    agregadoLinhasPorDia: [],
    config: null,
    isLinhaSelectDisabled: false,
    isVeiculoSelectDisabled: false,
    relatorioKey: 0,
    dialogRelatorio: false,
    dialog: false,
    editedItem: {
      id_viagem_prevista: null,
      id_quadro: null,
      descricao: null,
      horario_saida: null,
      horario_saida_previsto: null,
      horario_chegada: null,
      horario_chegada_previsto: null,
      escalonamento: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      id_viagem_realizada: null,
      dt_inicio: null,
      saida_realizada_extenso: null,
      dt_fim: null,
      chegada_realizada_extenso: null,
      id_veiculo: null,
      numero_ordem: null,
      id_motorista_validador: null,
      nome_motorista_validador: null,
      id_cobrador_validador: null,
      nome_cobrador_validador: null,
      id_linha: null,
      cod_linha: null,
      status: null,
      status_extenso: null,
      id_guia: null,
      guia_original: null,
      id_funcionario_motorista: null,
      id_funcionario_cobrador: null,
      id_motivo_saida: null,
      descricao_motivo_saida: null,
      id_motivo_chegada: null,
      descricao_motivo_chegada: null,
      observacoes: null,
      dt_abertura_manual: null,
      id_usuario_abertura_manual: null,
      dt_fechamento_manual: null,
      id_usuario_fechamento_manual: null,
      dt_associacao_manual: null,
      id_usuario_associacao_manual: null,
      id_cerca_inicio: null,
      id_cerca_fim: null,
      nome_cerca_inicio: null,
      nome_cerca_fim: null,
    },
    defaultItem: {
      id_viagem_prevista: null,
      id_quadro: null,
      descricao: null,
      horario_saida: null,
      horario_saida_previsto: null,
      horario_chegada: null,
      horario_chegada_previsto: null,
      escalonamento: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      id_viagem_realizada: null,
      dt_inicio: null,
      saida_realizada_extenso: null,
      dt_fim: null,
      chegada_realizada_extenso: null,
      id_veiculo: null,
      numero_ordem: null,
      id_motorista_validador: null,
      nome_motorista_validador: null,
      id_cobrador_validador: null,
      nome_cobrador_validador: null,
      id_linha: null,
      cod_linha: null,
      status: null,
      status_extenso: null,
      id_guia: null,
      guia_original: null,
      id_funcionario_motorista: null,
      id_funcionario_cobrador: null,
      id_motivo_saida: null,
      descricao_motivo_saida: null,
      id_motivo_chegada: null,
      descricao_motivo_chegada: null,
      observacoes: null,
      dt_abertura_manual: null,
      id_usuario_abertura_manual: null,
      dt_fechamento_manual: null,
      id_usuario_fechamento_manual: null,
      dt_associacao_manual: null,
      id_usuario_associacao_manual: null,
      id_cerca_inicio: null,
      id_cerca_fim: null,
      nome_cerca_inicio: null,
      nome_cerca_fim: null,
    },
    novoHorarioSaida: null,
    novoHorarioChegada: null,
    displayedItemsForExport: null,
    motivos: [],
    motivosViagem: [],
    itemDiario: {
      id_tipo_entrada_diario: null,
      id_motivo: null,
      id_usuario_inclusao: null,
      id_usuario_edicao: null,
      dt_entrada: null,
      dt_inclusao: null,
      dt_edicao: null,
      observacoes: null
    },
    defaultItemDiario: {
      id_tipo_entrada_diario: null,
      id_motivo: null,
      id_usuario_inclusao: null,
      id_usuario_edicao: null,
      dt_entrada: null,
      dt_inclusao: null,
      dt_edicao: null,
      observacoes: null
    },
    entradasDiario: [],
    tiposEntradaDiario: [],
    dtEntradaDiario: null,
    loadingDiario: false,
    diarioForm: null,
    tipoEntradaDisabled: false,
    diarioFormValidado: false,
    preferenciaGuiaValidador: {
      flag: 0,
      descricao: 'Guia',
      descricao_motorista: null,
      descricao_cobrador: null,
    },
    prefSelect: [
      { flag: 0, descricao: 'Guia' },
      { flag: 1, descricao: 'Validador' },
    ],
    didUpdateViagem: false,
    dialogObservacoesAuditoria: false,
    viagemObservacoesAuditoria: null,
    observacoesAuditoria: [],
    loadingObservacoesAuditoria: false,
    listaObservacoesAuditoria: "",
    headersObservacoesAuditoria: [],
  }),
  computed: {
    /** Atalho para a trilha completa na tela Auditoria de viagens (só para quem tem a tela). */
    podeVerTrilhaAuditoria() {
      const user = JSON.parse(sessionStorage.getItem('user') || 'null');
      if (user && user.is_superadmin) return true;
      try {
        const permissoes = JSON.parse(sessionStorage.getItem('permissoes') || '[]');
        return Array.isArray(permissoes) && permissoes.some((p) => p.nome_tela === 'AUDAuditoriaViagens');
      } catch (e) {
        return false;
      }
    },
    /** Meses fechados dentro do período consultado, para o aviso no topo. */
    mesesFechadosConsultados() {
      return this.mesesFechadosNoIntervalo(this.dti, this.dtf, this.idEmpresaSelected);
    },
    messageConfirmButton() { return this.$t('button.confirm') },
    messageDismissButton() { return this.$t('button.dismiss') },
    defaultMultiSortObservacoesAuditoria() {
      return [
        { value: "dt_auditoria", options: { text: this.$t('system.labels.increasing'), value: 1 } }]
    },
    defaultMultiSortViagens() {
      return [
        { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
    defaultMultiSortEmbarquesForaViagem() {
      return [
        { value: "dt_embarque", options: { text: this.$t('system.labels.decreasing'), value: -1 } }];
    },
    embarquesForaViagemFiltrados() {
      let list = (this.embarquesForaViagem || []).filter((e) => e.id_viagem == null);

      const linhasIds = this.idLinhaSelected.length === 0
        ? this.linhasSelect.map((l) => l.id_linha)
        : this.idLinhaSelected;
      if (linhasIds.length > 0) {
        list = list.filter((e) => linhasIds.includes(e.id_linha));
      }

      const veiculosIds = this.veiculosSelect.map((v) => v.id_veiculo);
      if (veiculosIds.length > 0) {
        list = list.filter((e) => veiculosIds.includes(e.id_veiculo));
      }

      return list.filter((e) => this.passaFiltroUnidades(e));
    },
    headersVeiculos() {
      return [
        { text: this.$t('relPredictedRealized.headersVehicle.vehicle'), value: "numero_ordem", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.total'), value: "n_viagens_totais", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.predicted'), value: "n_viagens_previstas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.realized'), value: "n_viagens_realizadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.predictedProdutive'), value: "n_viagens_previstas_produtivas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.realizedProdutive'), value: "n_viagens_realizadas_produtivas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.complete'), value: "n_viagens_completas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.incomplete'), value: "n_viagens_incompletas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.delayed'), value: "n_viagens_atrasadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.early'), value: "n_viagens_adiantadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.extras'), value: "n_viagens_extras", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.notRealized'), value: "n_viagens_nao_realizadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.lost'), value: "n_viagens_perdidas", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentPredicted'), value: "p_previstas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentRealized'), value: "p_realizadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentPredictedProdutive'), value: "p_previstas_produtivas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentRealizedProdutive'), value: "p_realizadas_produtivas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentComplete'), value: "p_completas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentIncomplete'), value: "p_incompletas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentDelayed'), value: "p_atrasadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentEarly'), value: "p_adiantadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentExtras'), value: "p_extras", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentNotRealized'), value: "p_nao_realizadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersVehicle.percentLost'), value: "p_perdidas", width: "10%", align: "center"}];
    },
    headersGuias() {
      return [
        { text: this.$t('relPredictedRealized.headersGuide.guide'), value: "numero_guia", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.total'), value: "n_viagens_totais", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.predicted'), value: "n_viagens_previstas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.realized'), value: "n_viagens_realizadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.predictedProdutive'), value: "n_viagens_previstas_produtivas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.realizedProdutive'), value: "n_viagens_realizadas_produtivas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.complete'), value: "n_viagens_completas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.incomplete'), value: "n_viagens_incompletas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.delayed'), value: "n_viagens_atrasadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.early'), value: "n_viagens_adiantadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.extras'), value: "n_viagens_extras", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.notRealized'), value: "n_viagens_nao_realizadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.lost'), value: "n_viagens_perdidas", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentPredicted'), value: "p_previstas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentRealized'), value: "p_realizadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentPredictedProdutive'), value: "p_previstas_produtivas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentRealizedProdutive'), value: "p_realizadas_produtivas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentComplete'), value: "p_completas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentIncomplete'), value: "p_incompletas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentDelayed'), value: "p_atrasadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentEarly'), value: "p_adiantadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentExtras'), value: "p_extras", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentNotRealized'), value: "p_nao_realizadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersGuide.percentLost'), value: "p_perdidas", width: "10%", align: "center"}];
    },
    headersLinhas() {
      return [
        { text: this.$t('relPredictedRealized.headersLine.line'), value: "cod_linha", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.total'), value: "n_viagens_totais", align:"center"},
        { text: this.$t('relPredictedRealized.headersLine.predicted'), value: "n_viagens_previstas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.realized'), value: "n_viagens_realizadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.predictedProdutive'), value: "n_viagens_previstas_produtivas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.realizedProdutive'), value: "n_viagens_realizadas_produtivas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.complete'), value: "n_viagens_completas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.incomplete'), value: "n_viagens_incompletas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.delayed'), value: "n_viagens_atrasadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.early'), value: "n_viagens_adiantadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.extras'), value: "n_viagens_extras", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.notRealized'), value: "n_viagens_nao_realizadas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.lost'), value: "n_viagens_perdidas", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentPredicted'), value: "p_previstas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentRealized'), value: "p_realizadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentPredictedProdutive'), value: "p_previstas_produtivas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentRealizedProdutive'), value: "p_realizadas_produtivas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentComplete'), value: "p_completas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentIncomplete'), value: "p_incompletas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentDelayed'), value: "p_atrasadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentEarly'), value: "p_adiantadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentExtras'), value: "p_extras", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentNotRealized'), value: "p_nao_realizadas", width: "10%", align: "center"},
        { text: this.$t('relPredictedRealized.headersLine.percentLost'), value: "p_perdidas", width: "10%", align: "center"}];
    },
    headerPorDia() {
      return { text: this.$t('relPredictedRealized.date'), value: "dt_referencia_extenso" };
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"
      }
    },
    loadingAgregado() {
      return this.loadingAgregadoLinhas || this.loadingAgregadoVeiculos || this.loadingAgregadoGuias;
    },
    sortByAgregado() {
      if (this.tab === 0) return "numero_ordem";
      if (this.tab === 1) return "numero_guia";
      return "cod_linha";
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min
      }
    },
    yesterday() {
      let td = new Date();
      td.setDate(td.getDate() - 1);
      return td.toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.yesterday
      }
    },
    semUnidadeOption() {
      return [
        {
          id_unidade: -1,
          descricao_unidade: 'Sem Unidade',
          cod_unidade: 'SU',
        },
      ];
    },
    lazySelectRequestData() {
      const unidades = (this.unidadesSelecionadas || []).map((id) => Number(id));
      const reais = unidades.filter((id) => Number.isFinite(id) && id > 0);
      const temSemUnidade = unidades.includes(-1);
      if (reais.length === 1 && !temSemUnidade) {
        return { id_unidade: reais[0] };
      }
      if (temSemUnidade && reais.length === 0) {
        return { id_unidade: -1 };
      }
      return {};
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    unidadesSelecionadas() {
      this.populaLinhasSelect();
      this.populaVeiculosSelect();
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.headersAgregado = this.headersVeiculos;
    this.agregado = this.agregadoVeiculos || [];
    this.initialize();
  },
  mounted() { },
  methods: {

    filtraItensLazyParaIds(dados) {
      if (!dados || !Array.isArray(dados)) {
        return [];
      }
      let filtrados = dados;
      if (this.idEmpresaSelected) {
        filtrados = filtrados.filter((d) => d.id_empresa == this.idEmpresaSelected);
      } else if (this.user && this.user.id_cliente != null && this.user.id_cliente !== '') {
        filtrados = filtrados.filter((d) => d.id_cliente == this.user.id_cliente);
      }
      if (this.unidadesSelecionadas.length > 0) {
        const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
        filtrados = filtrados.filter((d) => {
          if (Array.isArray(d.unidades) && d.unidades.length > 0) {
            return d.unidades.map((id) => Number(id)).some((u) => selecionadas.includes(u));
          }
          if (d.id_unidade != null && d.id_unidade !== '') {
            return selecionadas.includes(Number(d.id_unidade));
          }
          if (d.id_linha != null && d.id_veiculo == null && d.id_funcionario == null) {
            return true;
          }
          return selecionadas.includes(-1);
        });
      }
      return filtrados;
    },
    async resolveLazySelectIds(refName, selectedIds, valueKey) {
      if (Array.isArray(selectedIds) && selectedIds.length > 0) {
        return { ids: selectedIds, implicit: false };
      }
      const selectRef = this.$refs[refName];
      if (!selectRef || typeof selectRef.fetchAllLazyItems !== 'function') {
        return { ids: [], implicit: true };
      }
      const { items } = await selectRef.fetchAllLazyItems({
        search: '',
        requestDataOverride: this.lazySelectRequestData,
      });
      const ids = this.filtraItensLazyParaIds(items || [])
        .map((item) => item[valueKey])
        .filter((id) => id != null && id !== '');
      return { ids, implicit: true };
    },
    initialize() {
      this.getConfig();
      this.getHeaders();
      this.populaTiposEntrada();
      this.populaMotivos();
      this.populaEmpresas();
      this.populaLinhas();
      this.populaVeiculos();
      this.buildHeader();
    },
    logout() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("api");
      var id = window.setTimeout(function () {}, 0);
      while (id--) {
        window.clearTimeout(id);
      }
      this.$router.push({ path: "/" });
    },
    getHeaders() {
      let headersSession = JSON.parse(sessionStorage.getItem("headersPrevReal"));
      if (headersSession) {
        this.headers = headersSession;
      } else {
        apiController.request(apiController.endpoints.getHeaderstabela, {
          params: { cod: "RELPREVREAL" },
          silent: true,
          onSuccess: (response) => {
            this.headers = response.data;
            sessionStorage.setItem("headersPrevReal", JSON.stringify(this.headers));
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    populaTiposEntrada() {
      apiController.request(apiController.endpoints.getallTiposentrada, {
        silent: true,
        onSuccess: (response) => {
          this.tiposEntradaDiario = response.data;
        },
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaMotivos() {
      apiController.request(apiController.endpoints.getallMotivos, {
        silent: true,
        onSuccess: (response) => {
          this.motivos = response.data;
        },
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    /** Rotas agregadas / veículos: `unidades` (array) ou `id_unidade` — mesmo padrão do REL Passageiros. */
    idsUnidadesNoObjeto(o) {
      if (Array.isArray(o.unidades) && o.unidades.length) {
        return o.unidades.map((id) => Number(id));
      }
      if (o.id_unidade != null && o.id_unidade !== "") {
        return [Number(o.id_unidade)];
      }
      return [];
    },
    passaFiltroUnidades(o) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
      const rowUnidades = this.idsUnidadesNoObjeto(o);
      const semUnidadeSelected = selecionadas.includes(-1);
      const objetoSemUnidade = rowUnidades.length === 0 || rowUnidades.includes(-1);
      const matchesUnidade = selecionadas.some(
        (sid) => sid !== -1 && rowUnidades.includes(sid)
      );
      return matchesUnidade || (semUnidadeSelected && objetoSemUnidade);
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data || [];
        },
      });
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = response.data || [];
          this.populaLinhasSelect();
        },
      });
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        onSuccess: (response) => {
          this.veiculos = response.data || [];
          this.populaVeiculosSelect();
        },
      });
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
        },
      });
    },
    populaAgregadoVeiculos(body) {
      this.loadingAgregadoVeiculos = true;

      apiController.request(apiController.endpoints.getAgregadoprevrealizadoveiculos, {
        data: body,
        onSuccess: (response) => {
          let dados = response.data || [];
          dados = dados.filter((a) => this.passaFiltroUnidades(a));
          this.agregadoVeiculos = dados;
          this.populaAgregadoVeiculosPorDia(body);
        },
        onError: () => {
          this.loadingAgregadoVeiculos = false;
          this.agregadoVeiculos = [];
        },
      });
    },
    populaAgregadoVeiculosPorDia(body) {
      let params = { ...body };
      params.por_dia = true;

      apiController.request(apiController.endpoints.getAgregadoprevrealizadoveiculos, {
        data: params,
        onSuccess: (response) => {
          let dados = response.data || [];
          dados = dados.filter((a) => this.passaFiltroUnidades(a));
          this.agregadoVeiculosPorDia = dados;
          if (!this.agregado || this.agregado.length == 0) {
            this.buildHeader();
          }
          this.loadingAgregadoVeiculos = false;
        },
        onError: () => {
          this.loadingAgregadoVeiculos = false;
          this.agregadoVeiculosPorDia = [];
        },
      });
    },
    populaAgregadoGuias(body) {
      this.loadingAgregadoGuias = true;

      apiController.request(apiController.endpoints.getAgregadoprevrealizadoguias, {
        data: body,
        onSuccess: (response) => {
          let dados = response.data || [];
          dados = dados.filter((a) => this.passaFiltroUnidades(a));
          this.agregadoGuias = dados;
          this.populaAgregadoGuiasPorDia(body);
        },
        onError: () => {
          this.loadingAgregadoGuias = false;
          this.agregadoGuias = [];
        },
      });
    },
    populaAgregadoGuiasPorDia(body) {
      let params = { ...body };
      params.por_dia = true;

      apiController.request(apiController.endpoints.getAgregadoprevrealizadoguias, {
        data: params,
        onSuccess: (response) => {
          let dados = response.data || [];
          dados = dados.filter((a) => this.passaFiltroUnidades(a));
          this.agregadoGuiasPorDia = dados;
          if (!this.agregado || this.agregado.length == 0) {
            this.buildHeader();
          }
          this.loadingAgregadoGuias = false;
        },
        onError: () => {
          this.loadingAgregadoGuias = false;
          this.agregadoGuiasPorDia = [];
        },
      });
    },
    populaAgregadoLinhas(body) {
      this.loadingAgregadoLinhas = true;

      apiController.request(apiController.endpoints.getAgregadoprevrealizadolinhas, {
        data: body,
        onSuccess: (response) => {
          let dados = response.data || [];
          dados = dados.filter((a) => this.passaFiltroUnidades(a));
          this.agregadoLinhas = dados;
          this.populaAgregadoLinhasPorDia(body);
        },
        onError: () => {
          this.loadingAgregadoLinhas = false;
          this.agregadoLinhas = [];
        },
      });
    },
    populaAgregadoLinhasPorDia(body) {
        let params = {...body};
        params.por_dia = true;

        apiController.request(apiController.endpoints.getAgregadoprevrealizadolinhas, {
          data: params,
          onSuccess: (response) => {
            let dados = response.data || [];
            dados = dados.filter((a) => this.passaFiltroUnidades(a));
            this.agregadoLinhasPorDia = dados;
            if (!this.agregado || this.agregado.length == 0) {
              this.buildHeader();
            }
            this.loadingAgregadoLinhas = false;
          },
          onError: () => {
            this.loadingAgregadoLinhas = false;
            this.agregadoLinhasPorDia = [];
          },
        });
    },
    populaAgregados(body) {
      this.populaAgregadoLinhas(body);
      this.populaAgregadoVeiculos(body);
      this.populaAgregadoGuias(body);
    },
    async populaViagens() {
      this.loadingViagens = true;
      // Meses fechados da empresa, para avisar e bloquear a edição das viagens congeladas.
      this.carregaFechamentosMesAtivos(this.idEmpresaSelected);

      let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
      let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

      let id_linha;
      try {
        const linhasRes = await this.resolveLazySelectIds('linhasSelect', this.idLinhaSelected, 'id_linha');
        if (linhasRes.implicit && linhasRes.ids.length === 0) {
          this.loadingViagens = false;
          return;
        }
        id_linha = linhasRes.ids;
      } catch (_err) {
        this.loadingViagens = false;
        return;
      }

      let body = {
        id_linha,
        id_veiculo: this.veiculosSelect.map((v) => v.id_veiculo),
        dti: dataInicial,
        dtf: dataFinal,
        inicio_operacional: this.config.hora_inicial_dia_operacao.replaceAll(":", "") + "00"
      };

      apiController.request(apiController.endpoints.getPrevistorealizadolinhasdata, {
        data: body,
        onSuccess: (response) => {
          let dados = response.data || [];
          dados = dados.filter((v) => this.passaFiltroUnidades(v));
          this.viagens = dados;
          this.loadingViagens = false;
          this.populaAgregados(body);
        },
        onError: () => {
          this.loadingViagens = false;
        },
      });
    },
    populaEmbarquesForaViagem() {
      this.loadingEmbarquesForaViagem = true;

      const dti = DateUtils.getDateSQLFormatted(this.dti);
      const dtf = DateUtils.getDateSQLFormatted(this.dtf);

      apiController.request(apiController.endpoints.getallEmbarquesdata, {
        data: { dti, dtf },
        onSuccess: (response) => {
          this.embarquesForaViagem = (response.data && response.data.dados) || [];
          this.loadingEmbarquesForaViagem = false;
        },
        onError: () => {
          this.embarquesForaViagem = [];
          this.loadingEmbarquesForaViagem = false;
        },
      });
    },
    async populaRelatorio() {
      this.$refs.form.validate();
      if (this.formValidado) {
        this.viagens = [];
        this.embarquesForaViagem = [];
        this.displayedEmbarquesForaViagemForExport = null;
        this.agregado = [];
        this.agregadoVeiculos = [];
        this.agregadoGuias = [];
        this.agregadoLinhas = [];
        this.agregadoVeiculosPorDia = [];
        this.agregadoGuiasPorDia = [];
        this.agregadoLinhasPorDia = [];
        this.buildHeader();
        await this.populaViagens();
        this.populaEmbarquesForaViagem();
        this.$nextTick(() => { this.$refs.form.resetValidation(); });
      }
    },
    onEmpresaInput(id) {
      this.idEmpresaSelected = id;
      this.idLinhaSelected = [];
      if (this.$refs.linhasSelect && this.$refs.linhasSelect.setSelectedItems) {
        this.$refs.linhasSelect.setSelectedItems([]);
      }
      this.populaLinhasSelect();
      this.populaVeiculosSelect();
    },
    populaLinhasSelect() {
      let linhasFiltradas = this.linhas;
      if (this.idEmpresaSelected) {
        linhasFiltradas = this.linhas.filter((l) => l.id_empresa === this.idEmpresaSelected);
      }
      linhasFiltradas = linhasFiltradas.filter((l) => this.passaFiltroUnidades(l));

      // Remover linhas com id_linha duplicados, mantendo apenas o primeiro encontrado
      const seen = new Set();
      linhasFiltradas = linhasFiltradas.filter(linha => {
        if (seen.has(linha.id_linha)) {
          return false;
        }
        seen.add(linha.id_linha);
        return true;
      });
      
      this.linhasSelect = linhasFiltradas;
    },
    populaVeiculosSelect() {
      let veiculosFiltrados = this.veiculos;
      if (this.idEmpresaSelected) {
        veiculosFiltrados = veiculosFiltrados.filter((v) => v.id_empresa === this.idEmpresaSelected);
      }
      veiculosFiltrados = veiculosFiltrados.filter((v) => this.passaFiltroUnidades(v));
      this.veiculosSelect = veiculosFiltrados;
    },
    abrirRelatorioViagem(item) {
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.dt_fim === null) this.editedItem.dt_fim = DateUtils.getDateSQLFormatted(this.dt_final);
      this.relatorioKey = this.relatorioKey === 0 ? 1 : 0;
      this.dialogRelatorio = true;
    },
    closeRelatorio() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialogRelatorio = false;
    },
    buildHeader() {
      let tabHeaders = [];
      if (this.tab === 0) {
        if (this.porDia) {
          this.agregado = this.agregadoVeiculosPorDia || [];
          tabHeaders.push(this.headerPorDia);
        } else {
          this.agregado = this.agregadoVeiculos || [];
        }
        tabHeaders.push(...this.headersVeiculos);
      } else if (this.tab === 1) {
        if (this.porDia) {
          this.agregado = this.agregadoGuiasPorDia || [];
          tabHeaders.push(this.headerPorDia);
        } else {
          this.agregado = this.agregadoGuias || [];
        }
        tabHeaders.push(...this.headersGuias);
      } else if (this.tab === 2) {
        if (this.porDia) {
          this.agregado = this.agregadoLinhasPorDia || [];
          tabHeaders.push(this.headerPorDia);
        } else {
          this.agregado = this.agregadoLinhas || [] ;
        }
        tabHeaders.push(...this.headersLinhas)
      }
      this.headersAgregado = tabHeaders;
    },
    getWeatherIcon(item) {
      if (!item.condicao_climatica) {
        return null;
      }
      return item.condicao_climatica === this.$t('relTimePlate.rain') ? "mdi-weather-rainy" : "mdi-weather-sunny"
    },
    getWeatherIconColor(item) {
      if (!item.condicao_climatica) {
        return null;
      }
      return item.condicao_climatica === this.$t('relTimePlate.rain') ? "blue" : "orange"
    },
    getWeatherTemp(item) {
      if (!item.temp_media) {
        return null;
      }
      return `${item.temp_media} °C`;
    },
    formatDateString(dateString) {
      let year = dateString.substring(0, 4);
      let month = dateString.substring(4, 6);
      let day = dateString.substring(6, 8);
      let hour = dateString.substring(8, 10);
      let minute = dateString.substring(10, 12);
      let second = dateString.substring(12, 14);

      return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
    },
    saveEntrada() {
      this.diarioFormValidado = this.$refs.diarioForm.validate();
      if (this.diarioFormValidado) {
        this.itemDiario.dt_entrada = DateUtils.getDateSQLFormatted(this.dtEntradaDiario);
        this.itemDiario.id_usuario_inclusao = this.user.id_usuario;

        apiController.request(apiController.endpoints.insertEntrada, {
          data: this.itemDiario,
          silent: true,
          onSuccess: (response) => {
            if (this.editedItem.id_linha) {
              let entradasLinhas = [[response.data.insertId, this.editedItem.id_linha]];
              this.saveLinhasEntrada(entradasLinhas);
            }

            if (this.editedItem.id_veiculo) {
              let entradasVeiculos = [[response.data.insertId, this.editedItem.id_veiculo]];
              this.saveVeiculosEntrada(entradasVeiculos);
            }

            if (this.editedItem.id_viagem_realizada) {
              let entradasViagens = [[response.data.insertId, this.editedItem.id_viagem_realizada]];
              this.saveViagensEntrada(entradasViagens);
            }

            const tipoEntrada = this.tiposEntradaDiario.find((t) =>
              t.id_tipo_entrada_diario == this.itemDiario.id_tipo_entrada_diario
            );
            const motivo = this.motivos.find((m) =>
              m.id_motivo == this.itemDiario.id_motivo || m.id_motivos == this.itemDiario.id_motivo
            );

            this.entradasDiario.push({
              id_entrada_diario: response.data.insertId,
              id_tipo_entrada_diario: this.itemDiario.id_tipo_entrada_diario,
              descricao_tipo_entrada: tipoEntrada ? tipoEntrada.descricao_tipo_entrada : null,
              id_motivo: this.itemDiario.id_motivo,
              descricao_motivo: motivo ? motivo.descricao_motivo : null,
              dt_entrada: this.formatDateString(this.itemDiario.dt_entrada),
              observacoes: this.itemDiario.observacoes
            });
            this.itemDiario = Object.assign({}, this.defaultItemDiario);
            this.$refs.diarioForm.resetValidation();
          },
          onError: (e) => {
            console.log("ERRO AXIOS");
            console.log(e.message);
            this.tipoAlerta = "error";
            this.mensagemAlerta = e.message;
            this.showAlert = true;
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog =
                "Acesso não autorizado. Token de acesso inválido ou expirado !";
              this.autorizacaoDialog = true;
            }
          },
        });
      }
    },
    saveLinhasEntrada(entradasLinhas) {
      apiController.request(apiController.endpoints.insertLinhasentradabulk, {
        data: entradasLinhas,
        silent: true,
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          this.tipoAlerta = "error";
          this.mensagemAlerta = e.message;
          this.showAlert = true;
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    saveVeiculosEntrada(entradasVeiculos) {
      apiController.request(apiController.endpoints.insertVeiculosentradabulk, {
        data: entradasVeiculos,
        silent: true,
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          this.tipoAlerta = "error";
          this.mensagemAlerta = e.message;
          this.showAlert = true;
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    saveViagensEntrada(entradasViagens) {
      apiController.request(apiController.endpoints.insertViagensrealizadasentradabulk, {
        data: entradasViagens,
        silent: true,
        onError: (e) => {
          console.log("ERRO AXIOS");
          console.log(e.message);
          this.tipoAlerta = "error";
          this.mensagemAlerta = e.message;
          this.showAlert = true;
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    preencheEntradas(idViagemRealizada) {
      if (this.entradasDiario.length > 0) {
        let entradasVeiculos = this.entradasDiario.map((e) => {
          if (!e.id_veiculo) {
            return [e.id_entrada_diario, this.editedItem.id_veiculo];
          }
          return null;
        }).filter(Boolean);

        if (entradasVeiculos.length > 0) {
          this.saveVeiculosEntrada(entradasVeiculos);
        }

        let entradasLinhas = this.entradasDiario.map((e) => {
          if (!e.id_linha) {
            return [e.id_entrada_diario, this.editedItem.id_linha];
          }
          return null;
        }).filter(Boolean);

        if (entradasLinhas.length > 0) {
          this.saveLinhasEntrada(entradasLinhas);
        }

        let entradasViagens = this.entradasDiario.map((e) => {
          if (!e.id_viagem_realizada) {
            return [e.id_entrada_diario, idViagemRealizada]
          }
          return null;
        }).filter(Boolean);

        if (entradasViagens.length > 0) {
          this.saveViagensEntrada(entradasViagens);
        }
      }
    },
    populaEntradasDiario() {
      this.loadingDiario = true;
      let today = DateUtils.getDateSQLFormatted(new Date());
      let dataInicial = today.substring(0, 8) + "000000";
      let dataFinal = today;

      let body = {
        dti: dataInicial,
        dtf: dataFinal,
        idlinhas: null,
        idveiculos: null
      }

      if (this.editedItem.id_viagem_realizada) {
        body.idviagensrealizadas = [this.editedItem.id_viagem_realizada];
      } else {
        body.idviagensprevistas = [this.editedItem.id_viagem_prevista];
      }

      apiController.request(apiController.endpoints.getEntradaspordata, {
        data: body,
        silent: true,
        onSuccess: (response) => {
          this.entradasDiario = response.data;
          this.loadingDiario = false;
        },
        onError: (e) => {
          this.loadingDiario = false;
          console.log("ERRO AXIOS");
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    novoHorarioRules(horario) {
      return !!horario;
    },
    saveHorarioEdit(item) {
      if (this.novoHorarioSaida) {
        if (this.novoHorarioRules(this.novoHorarioSaida)) {
          item.dt_inicio = DateUtils.getDateSQLFormatted(this.novoHorarioSaida);
          item.dt_fim = DateUtils.getDateSQLFormatted(new Date(item.horario_chegada_realizada));
          item.saida_realizada_extenso = item.dt_inicio.substring(8, 10) + ":" + item.dt_inicio.substring(10, 12);
          item.id_usuario_abertura_manual = this.user.id_usuario;
          item.dt_abertura_manual = DateUtils.getDateSQLFormatted(new Date());
          item.sem_inicio = 0;
          this.buscarProximaViagemEAtualizar(item);
        }
      } else if (this.novoHorarioChegada) {
        if (this.novoHorarioRules(this.novoHorarioChegada)) {
          item.dt_fim = DateUtils.getDateSQLFormatted(this.novoHorarioChegada);
          item.dt_inicio = DateUtils.getDateSQLFormatted(new Date(item.horario_saida_realizada));
          item.chegada_realizada_extenso = item.dt_fim.substring(8, 10) + ":" + item.dt_fim.substring(10, 12);
          item.id_usuario_fechamento_manual = this.user.id_usuario;
          item.dt_fechamento_manual = DateUtils.getDateSQLFormatted(new Date());
          item.sem_final = 0;
          this.buscarProximaViagemEAtualizar(item);
        }
      }

      console.log(item);
      this.closeHorarioEdit();
    },
    buscarProximaViagemEAtualizar(item) {
      const proximaViagem = this.viagens.find(v =>
        v.id_veiculo === item.id_veiculo &&
        v.id_linha === item.id_linha &&
        v.id_turno === item.id_turno &&
        v.horario_saida_realizada > item.horario_saida_realizada
      );

      if (proximaViagem && proximaViagem.horario_saida_realizada) {
        item.horario_saida_proxima_viagem = proximaViagem.horario_saida_realizada;
      }

      this.updateViagem(item);
    },
    closeHorarioEdit() {
      this.novoHorarioChegada = null;
      this.novoHorarioSaida = null;
    },
    alterarPreferenciaGuiaValidador() {
      const payload = {
        id_viagem_grid: this.editedItem.id_viagem_grid,
        id_usuario: this.user.id_usuario,
        flag_alteracao_pref_guia_validador: this.preferenciaGuiaValidador.flag,
        id_motorista: this.preferenciaGuiaValidador.flag === 0 ? this.editedItem.id_motorista_guia_realizado : this.editedItem.id_motorista_validador_realizado,
        id_cobrador: this.preferenciaGuiaValidador.flag === 0 ? this.editedItem.id_cobrador_guia_realizado : this.editedItem.id_cobrador_validador_realizado,
        matricula_motorista: this.preferenciaGuiaValidador.flag === 0 ? this.editedItem.matricula_motorista_guia_realizado : this.editedItem.matricula_motorista_validador_realizado,
        matricula_cobrador: this.preferenciaGuiaValidador.flag === 0 ? this.editedItem.matricula_cobrador_guia_realizado : this.editedItem.matricula_cobrador_validador_realizado,
        nome_motorista: this.preferenciaGuiaValidador.flag === 0 ? this.editedItem.nome_motorista_guia_realizado : this.editedItem.nome_motorista_validador_realizado,
        nome_cobrador: this.preferenciaGuiaValidador.flag === 0 ? this.editedItem.nome_cobrador_guia_realizado : this.editedItem.nome_cobrador_validador_realizado,
      }

      apiController.request(apiController.endpoints.updatePrefguiavalidadorviagem, {
        data: payload,
        silent: true,
        onSuccess: (response) => {
          this.loadingUpdate = false;
          this.tipoAlerta = response.data.erro ? "error" : "success";
          this.mensagemAlerta = response.data.mensagem;
          this.showAlert = true;
          EventBus.$emit('show-alert', {
            mensagem: response.data.mensagem,
            tipo: response.data.erro ? 'error' : 'success'
          });
          this.preferenciaGuiaValidador = {
            flag: payload.flag_alteracao_pref_guia_validador,
            descricao: payload.flag_alteracao_pref_guia_validador === 0 ? 'Guia' : 'Validador',
            descricao_motorista: `(${payload.matricula_motorista}) ${payload.nome_motorista}`,
            descricao_cobrador: `(${payload.matricula_cobrador}) ${payload.nome_cobrador}`,
          };
          this.didUpdateViagem = true;
        },
        onError: (e) => {
          this.loadingUpdate = false;
          console.log("ERRO AXIOS");
          console.log(e.message);
          this.tipoAlerta = "error";
          this.mensagemAlerta = "Falha na atualização da viagem";
          this.showAlert = true;
          EventBus.$emit('show-alert', {
            mensagem: this.$t('relPredictedRealized.messages.errorUpdateTrip'),
            tipo: 'error'
          });
        },
      });
    },
    updateViagem(viagem) {
      this.loadingUpdate = true;
      viagem.processar_viagem = true;
      apiController.request(apiController.endpoints.updateViagemrealizada, {
        data: viagem,
        silent: true,
        onSuccess: (response) => {
          this.loadingUpdate = false;
          this.tipoAlerta = response.data.erro ? "error" : "success";
          this.mensagemAlerta = response.data.mensagem;
          this.showAlert = true;
          EventBus.$emit('show-alert', {
            mensagem: response.data.mensagem,
            tipo: response.data.erro ? 'error' : 'success'
          });
        },
        onError: (e) => {
          this.loadingUpdate = false;
          console.log("ERRO AXIOS");
          console.log(e.message);
          this.tipoAlerta = "error";
          this.mensagemAlerta = "Falha na atualização da viagem";
          this.showAlert = true;
          EventBus.$emit('show-alert', {
            mensagem: this.$t('relPredictedRealized.messages.errorUpdateTrip'),
            tipo: 'error'
          });
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              "Acesso não autorizado. Token de acesso inválido ou expirado !";
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    togglePorDia() {
      this.buildHeader();
    },
    abrirObservacoesAuditoria(item) {
      this.viagemObservacoesAuditoria = item.id_viagem_grid;
      apiController.request(apiController.endpoints.getObservacoesauditoriaviagem, {
        params: { idviagem: item.id_viagem_grid },
        silent: true,
        onSuccess: (response) => {
          this.observacoesAuditoria = response.data;
          if (this.observacoesAuditoria.length > 0) {
            if (this.observacoesAuditoria[0].observacao_horario_saida) {
              this.listaObservacoesAuditoria += this.observacoesAuditoria[0].observacao_horario_saida + "\n";
            }
            if (this.observacoesAuditoria[0].observacao_horario_chegada) {
              this.listaObservacoesAuditoria += this.observacoesAuditoria[0].observacao_horario_chegada + "\n";
            }
            if (this.observacoesAuditoria[0].observacao_sentido) {
              this.listaObservacoesAuditoria += this.observacoesAuditoria[0].observacao_sentido + "\n";
            }
          }
          this.dialogObservacoesAuditoria = true;
        },
        onError: (e) => {
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          EventBus.$emit('show-alert', {
            mensagem: this.$t('relPredictedRealized.messages.errorAuditAuth'),
            tipo: 'error'
          });
        },
      });
    },
    closeDialogObservacoesAuditoria() {
      this.observacoesAuditoria = [];
      this.dialogObservacoesAuditoria = false;
    },
    editViagem(item) {
      this.editedItem = Object.assign({}, item);
      this.preferenciaGuiaValidador = {
        flag: item.flag_alteracao_pref_guia_validador,
        descricao: item.flag_alteracao_pref_guia_validador === 0 ? 'Guia' : 'Validador',
        descricao_motorista: `(${item.matricula_motorista_realizado}) ${item.nome_motorista_realizado}`,
        descricao_cobrador: `(${item.matricula_cobrador_realizado}) ${item.nome_cobrador_realizado}`,
      };
      this.itemDiario = Object.assign({}, this.defaultItemDiario);
      this.dtEntradaDiario = null;
      this.populaEntradasDiario();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.preferenciaGuiaValidador = {
        flag: 0,
        descricao: 'Guia',
        descricao_motorista: null,
        descricao_cobrador: null,
      };
      this.entradasDiario = [];
      this.itemDiario = Object.assign({}, this.defaultItemDiario);
      if (this.didUpdateViagem) {
        this.didUpdateViagem = false;
        this.populaViagens();
      }
    },
  }
};
</script>
